<template>
<div class="MIndex" :style="{padding: showAppTips ? '1.98rem 0 0' : '0.88rem 0 0'}">
    <MHeader></MHeader>
    <div class="m-body">
        <MBanner></MBanner>
        <MCategory></MCategory>
        <MIndexList></MIndexList>
    </div>
    <transition name="slide-fade">
        <div class="gotop icon-gotop" @click="goTop" v-if="show"></div>
    </transition>
    <!-- <MTab></MTab> -->
</div>
</template>

<script>
import MBanner from 'views/mobile/index/components/mBanner'
import MCategory from 'views/mobile/index/components/mCategory'
import MIndexList from 'views/mobile/index/components/mIndexList'
// import MTab from 'views/mobile/components/tab/mTab'
import MHeader from 'views/mobile/components/mheader/mHeader'
import $ from 'jquery'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import {mapGetters} from 'vuex'
export default {
    name: 'MIndex',
    data() {
        return {
            show: false
        }
    },
    created() {
        document.title='鲸融课堂-资本实战派教育平台';
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'PHome'
            })
        }
    },
    activated() {
        $("html,body").animate({scrollTop:"0px"},0)
    },
    mounted() {
        if (this._isWixin()) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname
            getWXSDKSetting({
                title: '鲸融课堂-资本实战派教育平台',
                desc: '鲸融课堂是鲸融网推出的资本实战派在线教育平台，聚合大量优质教育机构和名师，主要为学习者提供海量、优质的资本实战派课程，用户可以根据自身的学习程度，自主安排学习进度。鲸融课堂立足于实用性的要求，与多家教育、培训机构建立合作，课程数量已达4100+，课时总数超50000,涵盖资本运营、商业管理、创业创新、职场技能、金融管理、考试认证等十余大门类。',
                link: link,
                imgUrl: 'http://img.capwhale.com/capwhale_logo.png'
            })
        }
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        goTop() {
            $("html,body").animate({scrollTop:"0px"},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['domainInfo', 'showAppTips'])
    },
    components: {
        MBanner,
        MCategory,
        MIndexList,
        // MTab,
        MHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.MIndex {
    position: relative;
    padding: 0.88rem 0 0;
    .m-body{
    }
    .gotop{
        position: fixed;
        right: 0.4rem;
        bottom: 1.76rem;
        width: 0.88rem;
        height: 0.88rem;
        opacity: 1;
    }
    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to{
        opacity: 0;
    }
}
</style>